var map = {
	"./1-1.png": "d69e",
	"./1-2.png": "4821",
	"./1-3.png": "46e4",
	"./1-4.png": "d81f",
	"./2-1.png": "9b2e",
	"./2-2.png": "1eb6",
	"./2-3.png": "caed",
	"./2-4.png": "3690",
	"./3-1.png": "3030",
	"./3-3.png": "01ab",
	"./3-4.png": "0cba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c818";